<template>
  <div class="icon-add">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="ionicon"
      viewBox="0 0 512 512"
    >
      <title>Add Circle</title>
      <path
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="32"
        d="M256 176v160M336 256H176"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: "Add",
};
</script>

<style scoped lang="scss">
.icon-add {
  width: 20px;
  // display: flex;
  // justify-content: center;
  // width: 60px;
  // height: 60px;
  // position: absolute;
  // margin-top: -25px;
  // background: #009BE7;
  // padding: 0px;
  // border-radius: 60px;
  // color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/icons/Add.vue